export default {
  learnMore: 'Learn more',
  gb: {
    title: '3 interest-free payments of {{installmentAmount}}. No fees.',
    steps: {
      addItemToCart: 'Add items(s) to your cart',
      chooseKlarna: 'Go to checkout and choose',
      enterInformation: 'Enter your debit or credit card information',
      checkEligibility: 'To check your eligibility, Klarna will perform a soft search with a credit reference agency. This will not affect your credit score.',
      explainPaymentPlan: 'Spread the cost in 3 interest-free payments. The first payment is made at point of purchase, with the remaining 2 payments scheduled automatically every 30 days. No fees.',
    },
    terms: 'You must be 18+ to use this credit offer. Klarna uses soft searches with credit reference agencies. These do not affect your credit rating. Missed payments can affect your ability to use Klarna. Pay in 3 complete {{linkOpen}}terms{{linkClose}}.',
  },
  klarnaLogoTitle: 'Klarna',
};
